import {
  GameSettingsServiceEvent,
  IGameSetting,
  IServices
} from "@netent/origin";
import { IPlayUIState, View } from "@netent/playui";
import { Store } from "redux";
import { settingsState } from "../../init/settings";
import { IStoreAction, IStoreState } from "../../store";
import { ListenerCreator } from "../../types";

const opened = () => (): IPlayUIState => ({
  view: View.MAIN_SETTINGS
});

const closed = () => (): IPlayUIState => ({
  view: View.DEFAULT
});

const changed = (
  services: IServices,
  store: Store<IStoreState, IStoreAction>
) => (setting: IGameSetting): IPlayUIState => {
  let stateChange: IPlayUIState = null;

  switch (setting.id) {
    case "leftHandMode":
      stateChange = {
        leftHandMode: {
          value: setting.value
        }
      };
      break;
    case "volume":
      stateChange = {
        volume: {
          value: setting.value,
          muted: services.gameSettings.getSetting("volumeMute")
        }
      };
      break;
    case "volumeMute":
      stateChange = {
        volume: {
          value: services.gameSettings.getSetting("volume"),
          muted: setting.value
        }
      };
      break;
    case "quickSpin":
      stateChange = {
        quickSpin: {
          active: setting.value
        }
      };
      break;
    default:
      break;
  }

  return {
    ...stateChange,
    settings: settingsState(services, store)
  };
};

export const listeners = new Map<GameSettingsServiceEvent, ListenerCreator>([
  ["opened", opened],
  ["closed", closed],
  ["changed", changed]
]);
